<template>
  <div>
    <v-navigation-drawer
        v-if="user"
        v-model="drawer"
        fixed
        temporary
      >
        <v-toolbar flat class="transparent">
          <v-list class="pa-0">
            <v-list-tile avatar>
              <!-- <v-list-tile-avatar>
                <img src="https://randomuser.me/api/portraits/men/36.jpg">
              </v-list-tile-avatar> -->

              <v-list-tile-content>
                <v-list-tile-title>{{ user ? user.name : '' }}</v-list-tile-title>
              </v-list-tile-content>

              <v-spacer></v-spacer>

              <v-icon id="closeDrawer" @click="drawer = !drawer">close</v-icon>
            </v-list-tile>
          </v-list>
        </v-toolbar>

        <v-list class="pt-0" dense>
          <v-divider></v-divider>

          <v-list-tile
            v-for="item in items"
            :key="item.title"
            router-link
            :to="item.path"
          >
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile
            tag="a"
            @click="logout"
          >
            <v-list-tile-action>
              <v-icon>exit_to_app</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>Logout</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>

      </v-navigation-drawer>

      <v-toolbar app flat color="transparent">

        <v-toolbar-side-icon @click="drawer = !drawer" v-if="user"></v-toolbar-side-icon>
        <v-spacer></v-spacer>

          <v-img
          :src="require('../assets/logo.png')"
          contain
          class="mt-2"
          style="cursor: pointer;"
          @click="$router.push('/')"
          max-height="70"
        ></v-img>

        <v-spacer></v-spacer>

      </v-toolbar>
  </div>
</template>

<script>

export default {
  name: 'Drawer',
  data () {
    return {
      drawer: false,
      items: [
        { title: 'Address Book', icon: 'contact_mail', path: '/address-book' },
        { title: 'Profile', icon: 'person', path: '/profile' }
      ],
      right: null
    }
  },
  computed: {
    user () {
      return this.$store.getters.user
    }
  },
  methods: {
    logout () {
      this.$store.dispatch('signOut')
    }
  }
}

</script>

<style>

</style>
